import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { IGetItemsResult } from '../../../../../httpClient/serverApi/types/IGetItemsResult';
import {
  IAnalyticsConnectionMetadata, IAnalyticsExtWorkbookId
} from '../../../../types/ISiteSettingsForSiteAdmin';

export interface IGetAnalyticsConnectionOptionsForWorkbookResult extends IGetItemsResult {
  connectionMetadataList: IAnalyticsConnectionMetadata[];
}

export class GetAnalyticsConnectionOptionsForWorkbookRequest extends TagRequest<{}, IGetAnalyticsConnectionOptionsForWorkbookResult> {
  constructor(WorkbookId: IAnalyticsExtWorkbookId) {
    super('analyticsextensions', 'getConnectionOptionsForWorkbook', WorkbookId);
  }
}
